import React, { useState } from "react";
import logo from "../images/logo.png";
export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    {
      id: 1,
      question: "1. Is there a contract?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
    },
    {
      id: 2,
      question: "2. How does the payment model work?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore."
    },
    {
      id: 3,
      question: "3. What about consultations?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus porta, velit in blandit egestas, orci elit luctus lorem."
    },
    {
      id: 4,
      question: "4. How do I order medication?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque vel dui sit amet tortor convallis consectetur."
    },
    {
      id: 5,
      question:
        "5. What happens after I place my order, and how will the doctor contact me?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec nisl non eros congue porttitor."
    },
    {
      id: 6,
      question: "6. How often will I have consultations?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas ac mauris vel justo posuere finibus."
    }
  ];
  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };
  return (
    <div className=" bg-white flex items-center justify-center px-4 font-poppins">

      <div className="w-full  relative">

      

        <h2 className="text-[16px] font-Medium text-black mb-4">
          Frequently asked questions
        </h2>

        <div className="space-y-2">
          {faqs.map((item, index) => (
            <div
              key={item.id}
              className="border border-gray-200 rounded-md bg-white"
            >

              <button
                type="button"
                onClick={() => handleToggle(index)}
                className="w-full flex items-center justify-between px-4 py-3 text-sm text-black"
              >
                <span className="text-left">{item.question}</span>
                <span className="text-xl leading-none text-gray-700">
                  {openIndex === index ? "▴" : "▾"}
                </span>
              </button>

              {openIndex === index && (
                <div className="px-4 pb-3 pt-1 text-xs text-gray-600 border-t border-gray-200">
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
